import { Box, Button, Dialog, DialogContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import ModalX from 'app/shared/ui/elements/Modal-X';

interface PhoneConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

const PhoneConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  isSubmitting = false,
}: PhoneConfirmationModalProps) => {
  const { t } = useTranslation('salary-card');

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <ModalX close={onClose} />
        <Box display='flex' flexDirection='column' alignItems='center' mt={4}>
          <img
            src='/images/digital_account/non_working_info.png'
            alt='phone confirmation'
            width={64}
            height={64}
          />
          <Typography fontSize={28} lineHeight={1.2} fontWeight='bold' align='center' my={3}>
            {t('cardExtension.confirmModal.title')}
          </Typography>
          <Typography fontSize={16} lineHeight={1.4} align='center'>
            {t('cardExtension.confirmModal.description')}
          </Typography>

          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: { xs: '12px', sm: '32px' },
              width: '100%',
              mt: 3,
            }}
          >
            <Button
              color='secondary'
              sx={{ flex: 1, height: 56 }}
              onClick={onClose}
              disabled={isSubmitting}
            >
              {t('cardExtension.confirmModal.back')}
            </Button>
            <Button sx={{ flex: 1, height: 56 }} onClick={onConfirm} disabled={isSubmitting}>
              {t('cardExtension.confirmModal.confirm')}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default PhoneConfirmationModal;
